import { call, put } from 'redux-saga/effects';
import {
  fetchTransactionItemsFailure,
  fetchTransactionItemsSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { FetchTransactionItemsRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { GetTransactionItemsResponse, getTransactionItems } from '../api';
import { TransactionItem } from '../models';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { isTransactionItemsEnabled } from 'utils/feature-flag-utils';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchTransactionItemsSaga(
  action: FetchTransactionItemsRequestAction
) {
  if (!isTransactionItemsEnabled()) return;

  const { organisationId } = action.payload;
  try {
    let err: ApiError | null;

    const response: GetTransactionItemsResponse = yield call(
      getTransactionItems,
      organisationId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const transactionItems: TransactionItem[] = Array.isArray(
      response.data?.data
    )
      ? response.data.data
      : [];

    yield put(fetchTransactionItemsSuccess(organisationId, transactionItems));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchTransactionItemsSuccess(organisationId, []));
    yield put(fetchTransactionItemsFailure());
  }
}
